(function(){
 'use strict';
 if(window.agibotCompactNavigation) return;
 window.agibotCompactNavigation=true;
 const desktop=matchMedia('(min-width:1150px)');
 const fine=matchMedia('(hover:hover) and (pointer:fine)');
 function productHandle(link){
  try{return new URL(link.getAttribute('href'),location.href).pathname.match(/\/products\/([^/]+)/)?.[1]||'';}catch{return '';}
 }
 function bootMobile(){
  document.querySelectorAll('#header-sidebar-menu .navigation-promo__wrapper .yg-products-list').forEach(list=>{
   if(list.dataset.agMobileReady)return;
   const rows=[...list.children].filter(row=>row.classList.contains('yg-products-item'));
   const records=rows.map(row=>({row,cards:[...row.querySelectorAll('a.yg-product-item')]}));
   if(!records.length||records.some(record=>!record.cards.length))return;
   const series=[
    {label:'AGIBOT D1',handles:['d1-pro','d1-edu','d1-ultra']},
    {label:'AGIBOT OmniHand',handles:['omnihand-2025','omnihand-2025-w-tactile']}
   ];
   const groups=[],used=new Set();
   records.forEach((record,index)=>{
    if(used.has(index))return;
    const group=series.find(series=>series.handles.includes(productHandle(record.cards[0])));
    const indices=group?records.map((other,i)=>group.handles.includes(productHandle(other.cards[0]))?i:-1).filter(i=>i>=0):[index];
    indices.forEach(i=>used.add(i));
    if(group)indices.sort((a,b)=>group.handles.indexOf(productHandle(records[a].cards[0]))-group.handles.indexOf(productHandle(records[b].cards[0])));
    groups.push({label:group?.label||record.row.querySelector('.yg-top-content .yg-product-title')?.textContent.trim()||'Products',cards:indices.flatMap(i=>records[i].cards)});
   });
   const catalog=document.createElement('div');catalog.className='ag-mobile-catalog';
   groups.forEach(group=>{
    const section=document.createElement('section');section.className='ag-mobile-product-group';
    const title=document.createElement('h3');title.className='ag-mobile-group-title';title.textContent=group.label;
    const grid=document.createElement('div');grid.className='ag-mobile-product-grid';
    const seen=new Set();
    group.cards.forEach(source=>{
     const href=source.getAttribute('href');if(!href||seen.has(href))return;seen.add(href);
     const card=source.cloneNode(true);card.className='ag-mobile-product-card';card.removeAttribute('style');
     card.querySelectorAll('yg-image').forEach(original=>{const image=document.createElement('div');image.className=original.className;while(original.firstChild)image.append(original.firstChild);original.replaceWith(image);});
     [card,...card.querySelectorAll('*')].forEach(element=>{
      element.removeAttribute('id');element.removeAttribute('tabindex');element.removeAttribute('aria-hidden');
      element.removeAttribute('aria-label');element.removeAttribute('role');
     });
     card.querySelectorAll('img').forEach(img=>{if(img.dataset.src)img.src=img.dataset.src;if(img.dataset.srcset)img.srcset=img.dataset.srcset;img.loading='lazy';});
     grid.append(card);
    });
    section.append(title,grid);catalog.append(section);
   });
   list.before(catalog);list.classList.add('ag-mobile-original');list.dataset.agMobileReady='true';
  });
 }
 function boot(){
  bootMobile();
  document.querySelectorAll('.header__link-list').forEach(nav=>{
   if(nav.dataset.agNavReady) return;
   nav.dataset.agNavReady='true';
   nav.querySelectorAll('yg-mega-menu').forEach(menu=>{
    const items=[...menu.querySelectorAll('.yg-product-item')];
    if(!menu.classList.contains('yg-layout-main-products')&&!menu.querySelector('.yg-accessory-products a')) menu.classList.add('ag-nav-single-preview');
    const tabs=[...menu.querySelectorAll('.yg-tab-item')];
    const groups=[
     {label:'AGIBOT D1',className:'ag-nav-d1-group',handles:['d1-pro','d1-edu','d1-ultra'],names:['AGIBOT D1 Pro','AGIBOT D1 Edu','AGIBOT D1 Ultra']},
     {label:'AGIBOT OmniHand',className:'ag-nav-omnihand-group',handles:['omnihand-2025','omnihand-2025-w-tactile'],names:['AGIBOT OmniHand 2025','AGIBOT OmniHand 2025(w.Tactile)']}
    ];
    const normalize=name=>(name||'').replace(/\s+/g,'').toLowerCase();
    const names=items.map(item=>normalize(item.querySelector('.yg-main-product .yg-product-title')?.textContent));
    const handles=items.map(item=>{
     const href=item.querySelector('.yg-main-product')?.getAttribute('href');
     try{return new URL(href,location.href).pathname.match(/\/products\/([^/]+)/)?.[1];}catch{return '';}
    });
    const matched=groups.map(group=>({...group,indices:group.names.map((name,i)=>items.findIndex((_,j)=>handles[j]===group.handles[i]||names[j]===normalize(name)))}))
     .filter(group=>group.indices.every(i=>i>=0)&&new Set(group.indices).size===group.indices.length);
    if(matched.length&&!menu.querySelector('.yg-accessory-products a')&&!menu.classList.contains('yg-layout-main-products')){
     menu.classList.add('ag-nav-series-group',...matched.map(group=>group.className));
     const categories=[],used=new Set();
     items.forEach((item,i)=>{
      if(used.has(i))return;
      const group=matched.find(group=>group.indices.includes(i));
      const category=group||{label:tabs[i]?.textContent.trim()||item.querySelector('.yg-product-title')?.textContent.trim()||'Products',indices:[i]};
      category.indices.forEach(index=>used.add(index));categories.push(category);
     });
     const sidebar=document.createElement('div');sidebar.className='ag-nav-series-sidebar';
     const controls=categories.map(category=>{
      const control=document.createElement(categories.length>1?'button':'div');
      control.className='ag-nav-series-label';control.textContent=category.label;
      if(categories.length>1)control.type='button';
      sidebar.append(control);return control;
     });
     function selectCategory(index){
      items.forEach((item,i)=>{
       const order=categories[index].indices.indexOf(i);
       item.classList.toggle('ag-nav-group-visible',order!==-1);
       item.style.setProperty('--ag-series-order',order);
       if(order!==-1&&desktop.matches)item.querySelectorAll('img[data-src]').forEach(img=>{img.src=img.dataset.src;});
      });
      controls.forEach((control,i)=>{
       control.classList.toggle('active',index===i);
       if(control.tagName==='BUTTON')control.setAttribute('aria-pressed',String(index===i));
      });
     }
     controls.forEach((control,i)=>{
      control.addEventListener('click',()=>selectCategory(i));
      control.addEventListener('pointerenter',()=>{if(desktop.matches&&fine.matches)selectCategory(i);});
      control.addEventListener('keydown',event=>{
       let next=i;
       if(event.key==='ArrowDown')next=(i+1)%controls.length;
       else if(event.key==='ArrowUp')next=(i-1+controls.length)%controls.length;
       else if(event.key==='Home')next=0;
       else if(event.key==='End')next=controls.length-1;
       else return;
       event.preventDefault();selectCategory(next);controls[next].focus();
      });
     });
     menu.prepend(sidebar);selectCategory(0);
    }
    function activate(i){
     tabs.forEach((tab,j)=>{tab.classList.toggle('active',i===j);});
     items.forEach((item,j)=>item.classList.toggle('active',i===j));
    }
    if(!items.some(item=>item.classList.contains('active'))) activate(0);
    tabs.forEach((tab,i)=>{
     tab.setAttribute('role','button');tab.tabIndex=0;
     tab.addEventListener('click',()=>{if(desktop.matches) activate(i);});
     tab.addEventListener('keydown',e=>{
      if(!desktop.matches) return;
      if(e.key==='Enter'||e.key===' '){e.preventDefault();activate(i);}
      if(e.key==='ArrowDown'||e.key==='ArrowUp'){
       e.preventDefault();const next=(i+(e.key==='ArrowDown'?1:-1)+tabs.length)%tabs.length;
       activate(next);tabs[next].focus();
      }
     });
    });
   });
   const menus=[...nav.querySelectorAll(':scope > ul > li > details')];
   menus.forEach(details=>{
    const original=details.getAttribute('trigger');
    const summary=details.querySelector(':scope > summary');
    let opening,closing;
    function cancel(){clearTimeout(opening);clearTimeout(closing);}
    function show(){
     menus.forEach(other=>{if(other!==details)other.open=false;});
     details.open=true;
     details.querySelectorAll('img[data-src]').forEach(img=>{img.src=img.dataset.src;img.loading='eager';});
    }
    function mode(){cancel();if(desktop.matches){details.setAttribute('trigger','click');}else{details.open=false;if(original!==null)details.setAttribute('trigger',original);}}
    mode();desktop.addEventListener('change',mode);
    details.addEventListener('pointerenter',()=>{if(!desktop.matches||!fine.matches)return;cancel();opening=setTimeout(show,180);});
    details.addEventListener('pointerleave',()=>{if(!desktop.matches||!fine.matches)return;cancel();closing=setTimeout(()=>{details.open=false;},220);});
    summary.addEventListener('keydown',e=>{if(desktop.matches&&e.key==='ArrowDown'){e.preventDefault();show();[...details.querySelectorAll('button,a,.yg-tab-item')].find(el=>el.getClientRects().length)?.focus();}});
    details.addEventListener('toggle',()=>{
     summary.setAttribute('aria-expanded',String(details.open));
     if(details.open) details.querySelectorAll('img[data-src]').forEach(img=>{img.src=img.dataset.src;});
    });
    document.addEventListener('pointerdown',e=>{if(desktop.matches&&!details.contains(e.target)){cancel();details.open=false;}});
    details.addEventListener('keydown',e=>{if(desktop.matches&&e.key==='Escape'){e.preventDefault();cancel();details.open=false;summary.focus();}});
    details.addEventListener('focusout',e=>{if(desktop.matches&&e.relatedTarget&&!details.contains(e.relatedTarget)){cancel();details.open=false;}});
   });
  });
 }
 document.readyState==='loading'?document.addEventListener('DOMContentLoaded',boot):boot();
 document.addEventListener('shopify:section:load',boot);
})();
